module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "size": 'lg'
    }
  }, [_c('div', {
    staticClass: "flex justify-between px-4 py-3"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('div', {
    staticClass: "avatar-circle center",
    style: ({
      backgroundImage: 'url(' + encodeURI(_vm.user.avatar_url) + ') ',
      'background-size': 'cover',
      'background-position': 'center',
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-headline ph3"
  }, [_vm._v(" " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-close"
  })])], 1), _vm._v(" "), _c('body', {
    staticClass: "flex-grow overflow-y-auto px-4 pb-3"
  }, [_c('pl-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "initialTab": _vm.initialTab,
      "minHeight": '400px',
      "headerWidth": '72%'
    }
  }, [_c('template', {
    slot: "tab-head-Details"
  }, [_c('span', {
    staticClass: "tab-title f1"
  }, [_vm._v("Details")])]), _vm._v(" "), _c('template', {
    slot: "tab-panel-Details"
  }, [_c('details-tab-content', {
    attrs: {
      "user": _vm.user,
      "userId": _vm.userId,
      "schoolSites": _vm.schoolSites
    },
    on: {
      "update-user-email": _vm.updateUserEmail
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "tab-head-Courses"
  }, [_c('span', {
    staticClass: "tab-title"
  }, [_vm._v("Courses ")])]), _vm._v(" "), _c('template', {
    slot: "tab-panel-Courses"
  }, [_c('courses-tab-content', {
    attrs: {
      "user": _vm.user,
      "systemWide": _vm.systemWide
    }
  })], 1), _vm._v(" "), (_vm.user.role === 'teacher') ? _c('template', {
    slot: "tab-head-Portfolio"
  }, [(_vm.user.role === 'teacher') ? _c('span', {
    staticClass: "tab-title"
  }, [_vm._v("Portfolio\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.role === 'teacher') ? _c('template', {
    slot: "tab-panel-Portfolio"
  }, [_c('portfolio-tab-content', {
    attrs: {
      "user": _vm.user
    }
  })], 1) : _vm._e()], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-51ef4036!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/userDetailsModal/userDetailsModal.vue
// module id = 2052
// module chunks = 61